Router = App.loadClass 'core::Router'

class exports.DaystoharvestRouter extends Router

    prefix: 'Daystoharvest'
    module_name: 'DaystoharvestRouter'

    register: () ->
        @module  = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service  'portal::Angular/Daystoharvest/DaystoharvestService', ['$http', '$rootScope', '$window']

        @controller  'portal::Angular/Daystoharvest/DaystoharvestController', ['$scope', '$transitions', 'Days', 'Daystoharvest.Services.DaystoharvestService', 'Core.Services.Loading']




    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.daystoharvest',
                url: '/daystoharvest'
                templateUrl: 'backend/portal/daystoharvest/ng-sidebar'
                controller: ['$scope', '$state', ($scope, $state) ->
                    # Do nothing but load the main dialog
                    $scope.show_fullpage = true
                    $state.go('portal.daystoharvest.dialog')
                ]

            .state 'portal.daystoharvest.dialog',
                url: '/dialog'
                views:
                    fullpage:
                        templateUrl: 'backend/portal/daystoharvest/ng-dialog'
                        controller: 'Daystoharvest.Controllers.DaystoharvestController'
                resolve:
                    'Days': [ 'Daystoharvest.Services.DaystoharvestService', (repository) =>
                        return repository.fetch().then (response) =>
                            jsr = response.data
                            return jsr
                    ]
